import React from "react";

import { Box, Item, List, Text } from "../elements";
import { CardHeader } from "../cards";
import { CardLayout } from "../v3";
import { get_date } from "../generalComponets";

/**
 * A component that renders a card displaying lead activities.
 *
 * @param {object} props - The component props.
 * @param {string} props.title - The title of the activity card.
 * @param {Array} props.items - An array of activity items to display.
 * @param {object} props.style - Additional styles for the activity list.
 * @returns {JSX.Element} The rendered lead activity card component.
 */
export const LeadActivityCard = ({ title, style, activities }) => {
  const formatDisplayValue = (value) => {
    if (value == null) return "None";

    if (Array.isArray(value)) {
      const formatted = value
        .filter((v) => v != null)
        .map(formatDisplayValue)
        .filter(Boolean)
        .join(", ");
      return formatted || "None";
    }

    if (typeof value === "object") {
      const fullName = [value.firstName, value.lastName].filter(Boolean).join(" ").trim();
      if (fullName) return fullName;
      if (value.name) return value.name;
      if (value.id != null) return `#${value.id}`;
      return "None";
    }

    return String(value);
  };

  const getChangeText = (change) => {
    const field = change?.field || "value";
    const oldValueText = formatDisplayValue(change?.oldValue);
    const newValueText = formatDisplayValue(change?.newValue);
    return `- ${field} changed from ${oldValueText} to ${newValueText}`;
  };

  return (
    <CardLayout className="mc-card">
      <CardHeader title={title} />
      <List className="mc-activity-card-list thin-scrolling" style={style}>
        {activities?.map((item, index) => (
          <Item key={index} className="mc-activity-card-item">
            <Box>
              <Text as="small">{item.note}</Text>
            </Box>
            <Box className="mc-activity-card-body">
              {/* activity item changes */}
              {item.changes &&
                item.changes.map((change, changeIndex) => (
                  <Text key={`${change.field}-${changeIndex}`} className="mc-activity-card-text">
                    {getChangeText(change)}
                  </Text>
                ))}

              <Text className="mc-activity-card-text" style={{ fontSize: 10 }}>
                {get_date(item.createdAt, "DD MMM YYYY HH:mm a")}
              </Text>

              {/* TODO: Add file handling */}
              {/* {item.file && (
                <Anchor href={item.file.path} className="mc-btn primary sm">
                  {item.file.label}
                </Anchor>
              )} */}
            </Box>
          </Item>
        ))}
      </List>
    </CardLayout>
  );
};
